import CartCoupon from '../../../../../ui/svg/shopping-cart/coupon';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import React from 'react';
import { useAppSelector } from '../../data/store';

const InstantSavings = () => {

    const cartData = useAppSelector(store => store.root.cartData);

    return (
        <>
            {
               cartData.priceData.totalUpsellDiscount > 0 &&
                <div className="text-gray-700 border border-green rounded bg-green-100 px-3 py-2 flex items-center mb-4">
                    <div className="text-green"><CartCoupon width="27" /></div>
                    <div className="flex flex-col mx-4 flex-1">Instant Savings</div>
                    <div className="text-green">
                        -<ProductPriceFormat price={ cartData.priceData.totalUpsellDiscount } />
                    </div>
                </div>
            }
        </>
    )
};

export default InstantSavings;